import PlusIcon from '@atlaskit/icon/core/migration/add--editor-add';
import type { NewCoreIconProps } from '@atlaskit/icon/types';

import type { ChartIcon } from './types/new-avp-experience/icons';

export const VIEW_TYPE_THUMBNAIL = 'THUMBNAIL';
export const VIEW_TYPE_LIST = 'LIST';

// New AVP Experience
export const BUTTON_ICONS: Record<
	ChartIcon,
	{
		(props: NewCoreIconProps): JSX.Element;
		displayName: string;
	}
> = {
	plus: PlusIcon,
};

export const AVP_OPTIONS_FIELD = 'clientSettings.options';

export const FORM_FIELDS = {
	chartType: 'chartType',
	metric: 'metric',
	title: 'title',
	description: 'description',
	rowsPerPage: 'rowsPerPage',
	isChartConfigurationPending: 'isChartConfigurationPending',
	pendingAsyncActionsCount: 'pendingAsyncActionsCount',
	isSelectedMetricDeprecated: 'isSelectedMetricDeprecated',
	placeholderValidator: 'placeholderValidator',
} as const;

export const ANALYTICS_CHANNEL = 'jsmReporting';

export const ARI_ENTITY_PREFIX = 'ari:';

export const GLOBAL_FILTERS_DIALOG_MIN_BOTTOM_GAP = 20;
export const GLOBAL_FILTERS_DIALOG_PADDING = 24;
export const GLOBAL_FILTERS_CTA_FOOTER_HEIGHT = 40;
